import React from 'react';
import { Alert, Chip, DialogContent, Stack, Typography } from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import OrderBookSummary from './OrderBookSummary';
import OrderProductListContainer from '../../../containers/projectmng/obtainorder/OrderProductListContainer';

import OrderBookApprovalContainer from '../../../containers/projectmng/obtainorder/OrderBookApprovalContainer';
import DetailTemplate from '../../common/template/DetailTemplate';

import SalesProfitInfoContainer from '../../../containers/projectmng/obtainorder/SalesProfitInfoContainer';
import OrderBookInfo from './OrderBookInfo';
import OrderBookFileListContainer from '../../../containers/projectmng/obtainorder/OrderBookFileListContainer';
import ApprovalV2HistoryPanel from '../../common/approval/ApprovalV2HistoryPanel';
import OrderApprovalV2Form from './OrderApprovalV2Form';

const OrderBookModal = ({
  project,
  lineId,
  approvalSteps,
  approvalLines,
  approvalLineLoading,
  currentUserUuid,
  approvalStepsError,
  setLineId,
  setApprovalSteps,
  approvalList,
  approvalV2Doc,
  approvalV2Steps,
  approvalV2Actions,
  finalApprovalAvailable,
  finalApprovalYn,
  finalApprovalComment,
  setFinalApprovalYn,
  setFinalApprovalComment,
  user,
  type,
  open,
  handleClose,
  orderInfo,
  scollToRef,
}) => {
  const showApprovalEditor = type === 'add'
    || (type === 'edit' && orderInfo?.crtUsr === user?.usrUuid && orderInfo?.ordYn === 'S');

  const showApprovalV2History = Boolean(approvalV2Doc);

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      fullScreen
      fullWidth={true}
    >
      <BootstrapDialogTitle onClose={handleClose}>수주품의서</BootstrapDialogTitle>

      <DialogContent
        dividers
        sx={{
          height: '90vh',
          overflowY: 'auto',
        }}
      >
        {type === 'edit' && (
          <DetailTemplate title="개요">
            <OrderBookSummary
              orderInfo={orderInfo}
              approvalList={approvalList}
              approvalV2Doc={approvalV2Doc}
            />
          </DetailTemplate>
        )}
        <div ref={scollToRef}></div>
        <DetailTemplate title="기본사항">
          <OrderBookInfo project={project} orderInfo={orderInfo} />
        </DetailTemplate>

        {type === 'edit' && (
          <DetailTemplate title="수주품의서 파일 리스트">
            <OrderBookFileListContainer orderInfo={orderInfo} />
          </DetailTemplate>
        )}

        <DetailTemplate title="최종 매출 이익 (내부거래 포함)">
          <SalesProfitInfoContainer orderInfo={orderInfo} project={project} />
        </DetailTemplate>

        {showApprovalEditor && (
          <DetailTemplate title="approval v2 결재선">
            <OrderApprovalV2Form
              approvalLines={approvalLines}
              approvalLineLoading={approvalLineLoading}
              lineId={lineId}
              approvalSteps={approvalSteps}
              currentUserUuid={currentUserUuid}
              approvalStepsError={approvalStepsError}
              finalApprovalAvailable={finalApprovalAvailable}
              finalApprovalYn={finalApprovalYn}
              finalApprovalComment={finalApprovalComment}
              onFinalApprovalYnChange={setFinalApprovalYn}
              onFinalApprovalCommentChange={setFinalApprovalComment}
              onApprovalLineChange={setLineId}
              onApprovalStepsChange={setApprovalSteps}
            />
          </DetailTemplate>
        )}

        {type === 'edit' && (
          <DetailTemplate title="결재 내역">
            {showApprovalV2History ? (
              <Stack spacing={2}>
                <Alert severity="info">
                  approval v2 문서번호: {approvalV2Doc.refDocNo || '-'} / 현재 결재자: {approvalV2Doc.currentActorNm || '-'}
                </Alert>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="body2" color="text.secondary">상태</Typography>
                  <Chip
                    size="small"
                    label={approvalV2Doc.docStatus || '-'}
                    color={approvalV2Doc.docStatus === 'APPROVED' ? 'success' : approvalV2Doc.docStatus === 'REJECTED' ? 'error' : 'warning'}
                  />
                </Stack>
                <ApprovalV2HistoryPanel steps={approvalV2Steps || []} actions={approvalV2Actions || []} />
              </Stack>
            ) : (
              <OrderBookApprovalContainer approvalList={approvalList} />
            )}
          </DetailTemplate>
        )}
        <DetailTemplate title="원가산출 내역">
          <OrderProductListContainer />
        </DetailTemplate>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default OrderBookModal;
